module.exports = __webpack_public_path__ + "static/media/aboutus-hero.d9989063.jpg";